<template>
    <div id="role_list">
        <div class="header">
            <span>请选择收货角色</span>
            <van-icon name="cross" color="#999" @click="close" />
        </div>
        <div class="role_area" v-if="!loading&&roleList.length > 0">
            <div class="role_box" v-for="(item,i) in roleList" :key="i">
                <div class="account">
                    账号：{{ item.account }}
                </div>
                <div class="roles">
                    <div v-for="(row,k) in item.roleList"
                        :key="k" @click="choose(row.role_id,row.role_name,row.server_id,item.account_id,row.server_name)" :class="{'role_item': true,'can':prop_server_id == row.server_id,'choosed': selection.role_id == row.role_id}" >
                        {{ row.server_name }}&nbsp;&nbsp;{{ row.role_name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="role-loading" v-if="!loading&&roleList.length == 0">
            <img class="no_role" src="../../assets/bx/acc/none.png"/>
            暂无角色
        </div>
        <div class="role-loading" v-if="loading">
            <van-loading></van-loading>
            <p>获取角色列表中,请稍后</p>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                app_id: this.selection.app_id,
                prop_server_id: this.selection.prop_server_id,
                loading: true,
                roleList: []
            };
        },
        props: ['selection'],
        computed: {

        },
        mounted() {
            this.getUserRoleList()
        },
        methods: {
            getUserRoleList() {
                this.$Ajax('user-info/user-role-list', {
                    app_id: this.app_id
                }).then(rs => {
                    this.loading = false
                    if (rs.code == 200) {
                        this.roleList = rs.data
                    }
                })
            },
            close() {
                // this.$emit('handleSuccess',{id: 0})
                this.$parent.handleClose()
            },
            choose(role_id, role_name, server_id,account_id,server_name) {
                this.$emit('handleSuccess', {
                    role_id,
                    role_name,
                    account_id,
                    server_id,
                    server_name
                })
                this.$parent.handleClose()
                
                // if (server_id != this.prop_server_id) {
                //     this.$toast({
                //         message: '您选择的角色与该商品不在同一区服',
                //         getContainer: '#role_list'
                //     })
                //     return
                // } else {
                    
                // }

            }
        },
    };
</script>
<style lang="less" scoped>
    .role-loading {
        margin: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #999;
        .no_role {
            width: 20rem;
        }
        p {
            margin-top: 2rem;
        }
    }
    #role_list {
        height: calc(var(--vh, 1)*60);
        display: flex;
        flex-direction: column;

        .header {
            height: 4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            font-size: 1.6rem;
            .van-icon {
                position: absolute;
                right: 2rem;
                top: 50%;
                transform: translateY(-50%);
                font-size: 2rem;
                cursor: pointer;
            }
        }

        .role_area {
            flex: 1;
            padding: 1.2rem 4rem;
            overflow-y: auto;
            .role_box {
                border-radius: 0.6rem;
                overflow: hidden;
                background-color: #fff;
                box-shadow: 0 0 3px 3px #eee;
                margin-bottom: 1.2rem;
                .account {
                    background-color: var(--theme);
                    padding: 0.8rem 2rem;
                    color: #fff;
                    font-size: 1.4rem;  
                }
                .roles {
                    .role_item {
                        padding: 0.8rem 2rem;
                        border-bottom: 1px solid #eee;
                        font-size: 1.3rem;
                        background-color: #aaaaaa;
                        color: #646464;
                        &.can {
                            background-color: #fff;
                            color: #000;
                        }
                        &.choosed {
                            background-color: var(--themebgc);
                            color: var(--fade5);
                        }
                    }
                }
            }
        }
    }
</style>